import { isKeycloakMode } from '@/config/env';
import { getKeycloak } from './keycloak';
import { logoutSession } from './use-auth';

/**
 * "Sair" nos dois modos de autenticação.
 *
 * - keycloak: limpa o estado local (token/usuário no localStorage) e roteia
 *   pelo end-session do Keycloak — só limpar o localStorage NÃO desloga: o
 *   próximo `check-sso` reautenticaria silenciosamente pela sessão SSO ainda
 *   válida no servidor.
 * - local: limpa a sessão e delega a navegação (SPA) ao chamador.
 */
export function performLogout(onLocalLogout: () => void): void {
  logoutSession();
  if (isKeycloakMode) {
    void getKeycloak().logout({ redirectUri: `${window.location.origin}/` });
    return;
  }
  onLocalLogout();
}
